import { useState, useEffect } from 'react';
import { Fade, IconButton } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => setVisible(window.pageYOffset > 400);
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <Fade in={visible}>
            <IconButton
                onClick={scrollToTop}
                aria-label="Scroll to top"
                size="small"
                sx={{
                    position: 'fixed',
                    bottom: 20,
                    right: 20,
                    width: 36,
                    height: 36,
                    bgcolor: 'custom.surface.elevated',
                    color: 'text.secondary',
                    border: t => `1px solid ${t.palette.custom.border.default}`,
                    boxShadow: t => t.customShadows.md,
                    '&:hover': {
                        bgcolor: 'custom.surface.elevated',
                        color: 'text.primary',
                        borderColor: 'custom.border.strong',
                    },
                }}
            >
                <KeyboardArrowUpIcon fontSize="small" />
            </IconButton>
        </Fade>
    );
};

export default ScrollToTopButton;
